var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Emit } from 'vue-property-decorator';
var ScrollEndEmitterMixin = /** @class */ (function (_super) {
    __extends(ScrollEndEmitterMixin, _super);
    function ScrollEndEmitterMixin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ScrollEndEmitterMixin.prototype.mounted = function () {
        var _this = this;
        this.$nextTick(function () {
            var _a = _this.$refs, dataList = _a.dataList, loadTrigger = _a.loadTrigger;
            var options = {
                root: dataList,
                rootMargin: '0px 0px 20px',
                threshold: 0
            };
            var handler = function (_a) {
                var entry = _a[0];
                if (entry.isIntersecting) {
                    _this.scrollEndEmitter();
                }
            };
            var observer = new IntersectionObserver(handler, options);
            observer.observe(loadTrigger);
            _this.$once('hook:beforeDestroy', function () {
                observer.disconnect();
            });
        });
    };
    // payloadを与えたい場合は利用側でoverrideして下さい
    ScrollEndEmitterMixin.prototype.scrollEndEmitter = function () { };
    __decorate([
        Emit('scroll-end')
    ], ScrollEndEmitterMixin.prototype, "scrollEndEmitter", null);
    ScrollEndEmitterMixin = __decorate([
        Component
    ], ScrollEndEmitterMixin);
    return ScrollEndEmitterMixin;
}(Vue));
export default ScrollEndEmitterMixin;
